export default "__VITE_ASSET__CSUAgdJ4__"